module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"postcode":"Postcode","validPostcode":"Postcode is valid","invalidPostcode":"The entered postcode is invalid. Please enter a correct UK postcode"}}}')
  delete Component.options._Ctor
}
